<dx-popup
  id="dialog-modif-mouvement"
  [(visible)]="displayDialog"
  [height]="'auto'"
  [width]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="modif-mouv-header">
    <div>
      <yo-icon icon="sign-in-alt"></yo-icon> <strong> Modifier le mouvement</strong>
    </div>

    <div class="modif-mouv-actions">
      <yo-button iconClass="fas fa-sign-out-alt" (onClick)="modifierMouvement()"
                 tooltip="Modifier le mouvement"
                 [theme]="ButtonThemeEnum.SAVE">
      </yo-button>
      <yo-button iconClass="fas fa-times"
                  [theme]="ButtonThemeEnum.CANCEL"
                 (onClick)="closeDialog()" tooltip="Annuler">
      </yo-button>
    </div>
  </div>

  <ng-container *ngIf="!utils.isNullOrEmpty(selectedStockMvt)">
    <form [formGroup]="form">
      <section class="modif-mouv-content">
        <div class="modif-mouv-list">
          <div class="modif-mouv-row">
            <span>Nom Denrée</span>
            <strong>{{selectedStockMvt.denominationArticle}}</strong>
          </div>
          <div class="modif-mouv-row">
            <span>Motif</span>
            <div>
              <ng-container *ngTemplateOutlet="tplEntreeSortie;context:{rowData:this.selectedStockMvt}"></ng-container>
              <strong> {{selectedStockMvt.stockMouvementStatutLibelle}}</strong>
            </div>
          </div>
          <div class="modif-mouv-row">
            <div title="Quantité">Quantité</div>
            <div class="modif-mouv-text-box">
              <yo-text-box
                (keydown)="utils.keydownNumber($event,form,'quantite',true)"
                id="quantite"
                [value]="form.get('quantite').value"
                (onValueChanged)="form.get('quantite').setValue($event)">
              </yo-text-box>
              <div>
                <span id="qte"
                      *ngIf="selectedStockMvt.uniteDeStockage && selectedStockMvt.uniteDeStockage != ''"><strong>{{selectedStockMvt.uniteDeStockage}}</strong></span>
                <ng-container
                  *ngTemplateOutlet="tplError;context:{form:form,property:'quantite',label:'quantité'}"></ng-container>
              </div>
            </div>
          </div>
          <div class="modif-mouv-row">
            <ng-container *ngIf="selectedStockMvt.entreeSortie">
              <div title="Prix">Prix unitaire</div>
              <div class="modif-mouv-box">
                <yo-text-box
                  (keydown)="utils.keydownNumber($event,form,'prixUnitaire',true)"
                  id="prixUnitaire"
                  [value]="form.get('prixUnitaire').value"
                  (onValueChanged)="form.get('prixUnitaire').setValue($event)">
                </yo-text-box>
                <ng-container
                  *ngTemplateOutlet="tplError;context:{form:form,property:'prixUnitaire',label:'prix unitaire'}"></ng-container>
              </div>
            </ng-container>
          </div>
          <div class="modif-mouv-row">
            <div>Remarque</div>
            <div>
              <textarea formControlName="remarque"></textarea>
              <ng-container
                *ngTemplateOutlet="tplError;context:{form:form,property:'remarque',label:'Remarque'}"></ng-container>
            </div>
          </div>
          <div class="modif-mouv-row">
            <div>Date de mouvement</div>
            <div>
              <dx-date-box
                [displayFormat]="'EEE d MMM yy'"
                formControlName="dateMouvement"
                [inputAttr]="{ 'aria-label': 'Date' }">
              </dx-date-box>
              <ng-container
                *ngTemplateOutlet="tplError;context:{form:form,property:'dateMouvement',label:'date de mouvement'}"></ng-container>
            </div>
          </div>

        </div>
      </section>
    </form>
  </ng-container>

</dx-popup>

<!--TEMPLATE ERREUR FORMULAIRE-->
<ng-template #tplError let-form="form" let-property="property" let-label="label" let-site="site">
  <div class="error"
       *ngIf="form.controls[property].invalid && (form.controls[property].dirty || form.controls[property].touched )">

    <pre>{{form.controls[property].validators | json}}</pre>

    <div class="pg-2" *ngIf="form.controls[property].hasError('required')">
      {{startError(label)}} est obligatoire.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('minlength')">
      {{startError(label)}} ne peut avoir moins de {{form.controls[property].errors.minlength}} caractères.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('aucunparamzds')">
      {{startError(label)}} est obligatoire. Veuillez paramétrer les zones de stockage de l'unité de
      production {{site.libelle | uppercase}}.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('maxlength')">
      {{startError(label)}} ne peut dépasser {{form.controls[property].errors.maxlength}} caractères.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('min')">
      {{startError(label)}} doit être supérieur ou égal à {{form.controls[property].errors.min.min}}.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('max')">
      {{startError(label)}} doit être inférieur ou égal à {{form.controls[property].errors.max.max}}.
    </div>

  </div>

</ng-template>

<!--TEMPLATE ENTREE / SORTIE-->
<ng-template #tplEntreeSortie let-rowData="rowData">

  <ng-container *ngIf="rowData.entreeSortie">
    <i class="fas fa-arrow-right bold new-color" title="Entrée de stock"
       ></i>
  </ng-container>

  <ng-container *ngIf="!rowData.entreeSortie">
    <i class="fas fa-arrow-left bold danger-color" title="Sortie de stock"
       ></i>
  </ng-container>

</ng-template>
